import React, { useRef, useState } from 'react';

import { usePaymentContext } from 'features/payment';
import { Button } from 'native-base';
import { useIntl } from 'react-intl';

import { InlineModal } from 'components/ui';
import useErrorModal from 'hooks/use-error-modal';

import { AddEditPaymentMethod, PaymentMethodRef } from './add-new-method';

export function AddPaymentMethodModal() {
  const addMethodRef = useRef<PaymentMethodRef | null>(null);
  const {
    setIsAddCreditCardModalVisible,
    isAddCreditCardModalVisible,
    isAddUpdateCardForReloadModalVisible,
    setIsAddUpdateCardForReloadModalVisible,
    accountToDelete: accountToUpdate, // This is actually account to update
  } = usePaymentContext();
  const { formatMessage } = useIntl();
  const isOpen = isAddCreditCardModalVisible || isAddUpdateCardForReloadModalVisible;
  const [isLoading, setIsLoading] = useState(false);
  const [canSubmit, setCanSubmit] = useState(true);
  const [ErrorDialog, openErrorDialog] = useErrorModal({
    modalAppearanceEventMessage: 'Error: Vaulting Credit/Debit Card',
  });

  const title = accountToUpdate
    ? formatMessage({ id: 'updateCard' })
    : formatMessage({ id: 'addCreditDebitCard' });

  const handleClose = () => {
    setIsAddCreditCardModalVisible(false);
    setIsAddUpdateCardForReloadModalVisible(false);
  };

  return (
    <InlineModal
      isOpen={isOpen}
      webSize={{ width: '30%', height: 'auto', minWidth: 480 }}
      header={{
        title,
        closeIconPosition: 'right',
        variant: 'light',
      }}
      footer={
        <Button
          onPress={() => {
            if (addMethodRef.current) {
              addMethodRef.current.addNewCard();
            }
          }}
          size="md"
          width="80%"
          isDisabled={!canSubmit || isLoading}
          isLoading={isLoading}
        >
          {formatMessage({ id: 'continue' })}
        </Button>
      }
      onClose={handleClose}
    >
      <AddEditPaymentMethod
        isLoading={isLoading}
        isPrepaidReload={isAddUpdateCardForReloadModalVisible}
        setIsLoading={setIsLoading}
        openErrorDialog={openErrorDialog}
        setCanSubmit={setCanSubmit}
        ref={addMethodRef}
      />
      <ErrorDialog />
    </InlineModal>
  );
}
